import { render } from "./PDFFormationSection.vue?vue&type=template&id=ad31cb66"
import script from "./PDFFormationSection.vue?vue&type=script&lang=js"
export * from "./PDFFormationSection.vue?vue&type=script&lang=js"

import "./PDFFormationSection.vue?vue&type=style&index=0&id=ad31cb66&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__